import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MySelectInput = ({ label, options, ...props }) => {
  const [field] = useField(props)

  return (
    <div className={`${props.inputclass}`}>
      <label
        className="mt-2 block text-sm font-medium capitalize text-gray-700"
        htmlFor={props.id || props.name}
      >
        {label}
      </label>
      <select
        className={
          'mt-1 block w-full rounded-md border-gray-300 shadow-sm ' +
          'focus:border-gray-500 focus:ring-gray-500 sm:text-sm'
        }
        value={(item) => (item.name ? item.name : item.value)}
        {...field}
        {...props}
      >
        {options?.map((item, index) => (
          <option
            key={index}
            name={item.id}
            value={item.name ? item.name : item.code}
          >
            {item.value}
          </option>
        ))}
      </select>
    </div>
  )
}
export default MySelectInput

MySelectInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  options: PropTypes.arrayOf(PropTypes.object),
  inputclass: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
}
